import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  registerCompanyAwayDetail(context, payload) {
    ApiService.setHeader();
    return ApiService.post("company/away/management", payload).then(
      (response) => response
    );
  },
};

export default {
  actions,
};
